import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../translations';

interface Props { language: Language; }

export const ConfirmationScreen: React.FC<Props> = ({ language }) => {
  const t = TRANSLATIONS[language]?.ownerPartnership?.confirm || TRANSLATIONS[Language.EN].ownerPartnership.confirm;
  return (
    <div className="w-full max-w-2xl mx-auto bg-white p-8 md:p-16 shadow-xl border-t-4 border-green-700 text-center animate-in fade-in zoom-in duration-500">
      <div className="w-20 h-20 bg-green-50 text-green-700 rounded-full flex items-center justify-center mx-auto mb-8">
        <i className="fa-solid fa-check text-3xl"></i>
      </div>
      
      <h2 className="text-3xl font-heading uppercase tracking-widest mb-4">
        {t.title}
      </h2>
      <p className="text-neutral-600 mb-10 leading-relaxed max-w-md mx-auto">
        {t.desc}
      </p>

      {/* Future Architecture Placeholders */}
      <div className="border-t border-neutral-100 pt-8 mt-8 text-left space-y-6">
        <h4 className="text-sm font-bold uppercase tracking-widest text-neutral-400 mb-4 text-center">
          {t.nextSteps}
        </h4>
        
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-neutral-50 flex items-center justify-center text-neutral-400 shrink-0">
            <i className="fa-regular fa-calendar"></i>
          </div>
          <div>
            <h5 className="font-bold text-sm uppercase mb-1">{t.bookTitle}</h5>
            <p className="text-xs text-neutral-500">{t.bookDesc}</p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-neutral-50 flex items-center justify-center text-neutral-400 shrink-0">
            <i className="fa-regular fa-file-pdf"></i>
          </div>
          <div>
            <h5 className="font-bold text-sm uppercase mb-1">{t.dlTitle}</h5>
            <p className="text-xs text-neutral-500">{t.dlDesc}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
